import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['notificationBox', 'flashMessage'];

  connect() {
    document.body.addEventListener(
      'notification:show',
      this.handleShowNotification.bind(this)
    );
    document.body.addEventListener(
      'notification:clear',
      this.clearNotification.bind(this)
    );
    this.closeTimeout = null;
    this.notificationBoxTarget.addEventListener(
      'click',
      this.clearNotification.bind(this)
    );
  }

  flashMessageTargetConnected(element) {
    const message = element.textContent;
    if (message.length > 0) {
      const type = element.dataset.notificationType;
      const timeoutInMs = element.dataset.timeoutInMs;
      this.showNotification(message, { timeoutInMs, type });
      element.remove();
    }
  }

  handleShowNotification(event) {
    const message = event.detail.message;
    const timeoutInMs = event.detail.timeoutInMs;
    const type = event.detail.type;

    this.showNotification(message, { timeoutInMs, type });
  }

  show({ params: { message } }) {
    this.showNotification(message);
  }

  showNotification(message, { timeoutInMs = 3000, type = 'default' } = {}) {
    this.notificationBoxTarget.dataset.notificationType = type;

    if (this.closeTimeout) this.clearNotification();
    this.notificationBoxTarget.innerHTML = message;
    this.notificationBoxTarget.hidden = false;
    this.closeTimeout = setTimeout(
      this.clearNotification.bind(this),
      timeoutInMs
    );
  }

  clearNotification() {
    clearTimeout(this.closeTimeout);
    this.notificationBoxTarget.hidden = true;
  }
}

export function showNotification(message, options = {}) {
  options.message = message;
  document.body.dispatchEvent(
    new CustomEvent('notification:show', { bubbles: true, detail: options })
  );
}

export function clearNotification() {
  document.body.dispatchEvent(
    new CustomEvent('notification:clear', { bubbles: true })
  );
}
